import React from 'react'
import Dropzone from 'react-dropzone-legacy'
import './uploadImageComponent.scss'
import StorageService from '@services/StorageApiClient'
import moment from 'moment'
import uuid from 'uuid/v4'

export const uploadImageComponent = ({ input, meta, label, disabled = false }) => {
  const storageService = new StorageService()

  const handleDrop = (files) => {
    let timeStamp = moment().utc().format('YYYYMMDDHHmmss')
    let key = `${timeStamp}_${uuid()}`
    storageService.publicUpload(key, files[0]).then((url) => {
      input.onChange(url)
    })
  }

  const errorClassName = meta.error && meta.submitFailed ? 'mp-image-upload--error' : ''
  return (
    <div className={`avatar-upload ${disabled && 'disabled'}`}>
      <label>{label}</label>
      <Dropzone
        className={`mp-image-upload ${errorClassName}`}
        maxSize={1000000}
        accept="image/jpeg, image/jpg, image/png"
        onDropAccepted={handleDrop}
      >
        {input.value && <img src={input.value} alt="dropImage" />}
      </Dropzone>
      <span className={'form-group'}> [ 1Mb max ] </span>
      {meta.error && meta.touched && <div className="error">{meta.error}</div>}
    </div>
  )
}
